export const DIVE_IN_ACTION_ID = "diveIn-action";
export const DIVE_IN_ACTION_BUTTON_CLASSNAME = "white-action";